<div class="wrap">
    <div class="container">
        <div class="img">
            
            <!-- <img src="/assets/img/ramdam_error.png" alt="erreur"> -->
             <img src="/assets/img/TOURNAIRAMDAMFEST.png" alt="erreur" >
        </div>
    
        <p>Oups ! Une erreur est survenue !</p>
    </div>
</div>